/*
 * Author: Dw
 * File Created: Wednesday, 24-08-07 03:14 pm
 * Last Modified: Monday, 25-03-17 03:17 pm, by Harper Yan
 */

import type { FC } from 'react';
import React, { useRef, useState } from 'react';
import { Box, Divider } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import { locales } from '@/constants';
import useLanguage from '@/hooks/useLanguage';
const DEFAULT_LANG_HEIGHT = 36;
const supportedLangList = locales.map(item => ({
  label: item.split('-')[0]?.toLocaleUpperCase(),
  value: item
}));
const PCSwitcher: FC<{
  onChange?: (locale: string) => void;
}> = ({
  onChange
}) => {
  const lang = useLanguage().curLocale;
  const langRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(DEFAULT_LANG_HEIGHT);
  const {
    setLocale
  } = useLanguage();
  const isActiveLang = (item: (typeof supportedLangList)[number]) => {
    return item.label === lang.toUpperCase();
  };
  const onLocaleChange = (item: (typeof supportedLangList)[number]) => {
    if (isActiveLang(item)) {
      return;
    }
    setLocale(item.value);
    onChange?.(item.value);
  };
  const isOpen = height !== DEFAULT_LANG_HEIGHT;
  return <Box height={DEFAULT_LANG_HEIGHT} onMouseEnter={() => {
    if (langRef.current) {
      setHeight(langRef.current.offsetHeight);
    }
  }} onMouseLeave={() => {
    setHeight(DEFAULT_LANG_HEIGHT);
  }} position="relative" width={DEFAULT_LANG_HEIGHT} data-sentry-element="Box" data-sentry-component="PCSwitcher" data-sentry-source-file="LanguageSwitcher.tsx">
      <Box position="absolute" right={0} sx={{
      borderRadius: '18px',
      // border: `2px solid #fff`,
      background: isOpen ? '#383637' : 'transparent',
      overflow: 'hidden',
      width: DEFAULT_LANG_HEIGHT,
      height: `${height}px`,
      transition: 'all 0.2s'
    }} data-sentry-element="Box" data-sentry-source-file="LanguageSwitcher.tsx">
        <Box alignItems="center" display="flex" flexDirection="column" ref={langRef} sx={{
        marginTop: '8px',
        pb: 2,
        px: 2,
        fontSize: '16px'
      }} data-sentry-element="Box" data-sentry-source-file="LanguageSwitcher.tsx">
          <Icon name="Earth" sx={{
          mb: 0.5
        }} data-sentry-element="Icon" data-sentry-source-file="LanguageSwitcher.tsx" />
          {supportedLangList.map(item => <Box color={isActiveLang(item) ? '#fff' : '#848E9C'} component="div" key={item.value} onClick={() => {
          onLocaleChange(item);
        }} py={0.5} sx={{
          cursor: 'pointer',
          pointerEvents: 'all'
        }} title={item.value}>
              {item.label === 'ZH' ? 'CH' : 'EN'}
            </Box>)}
        </Box>
      </Box>
    </Box>;
};
const MobileSwitcher: FC<{
  onChange?: (locale: string) => void;
}> = ({
  onChange
}) => {
  const lang = useLanguage().curLocale;
  const {
    setLocale
  } = useLanguage();
  const isActiveLang = (item: (typeof supportedLangList)[number]) => {
    return item.label === lang.toUpperCase();
  };
  const onLocaleChange = (item: (typeof supportedLangList)[number]) => {
    if (isActiveLang(item)) {
      return;
    }
    setLocale(item.value);
    onChange?.(item.value);
  };
  return <Box alignItems="center" display="flex" justifyContent="flex-end" data-sentry-element="Box" data-sentry-component="MobileSwitcher" data-sentry-source-file="LanguageSwitcher.tsx">
      {/* <Icon name='Earth' /> */}
      {supportedLangList.map((item, index) => <Box alignItems="center" display="flex" key={item.value}>
          <Box color={isActiveLang(item) ? '#fff' : '#848E9C'} component="div" key={item.value} onClick={() => {
        onLocaleChange(item);
      }} px="12px" py={0.5} sx={{
        cursor: isActiveLang(item) ? 'unset' : 'pointer'
      }} title={item.value}>
            {item.label === 'ZH' ? 'CH' : 'EN'}
          </Box>
          {index !== supportedLangList.length - 1 ? <Divider color="#D9D9D9" orientation="vertical" sx={{
        width: '2px',
        height: '16px'
      }} /> : null}
        </Box>)}
    </Box>;
};
const LanguageSwitcher: FC<{
  isMobile?: boolean;
}> = ({
  isMobile
}) => {
  return isMobile ? <MobileSwitcher data-sentry-element="MobileSwitcher" data-sentry-component="LanguageSwitcher" data-sentry-source-file="LanguageSwitcher.tsx" /> : <PCSwitcher data-sentry-element="PCSwitcher" data-sentry-component="LanguageSwitcher" data-sentry-source-file="LanguageSwitcher.tsx" />;
};
export default LanguageSwitcher;